import { alertActions } from "../alert/Actions";
import { bootstrapActions } from "../bootstrap/Actions";
import { assetActions } from "../dashboard/asset/actions";
import { userConstants } from "./Constants";
import { userService } from "./Service";
import { checkSopAccess } from "../sops/services";
import {
  apiHost,
  clearTokenCookie,
  clearCredentials,
  getCredentials,
  setCredentials,
  getFeatureToggle,
  getLocale,
  history,
  getCookie,
  setTokenCookie,
} from "../../components/common/helpers";
import { redirectOnLogin } from "../home/common/helpers";
import { Mixpanel } from "../common/utils";

export const userActions = {
  login,
  logout,
  autologin,
  registration,
  userData,
  bootstrap,
  socialLogin,
  updateUser,
  setOrgUserList,
  loginToAdminPortal,
  logoutFromAdminPortal,
};

const persistSopAccess = (emailAddr, token) => (dispatch) => {
  checkSopAccess(emailAddr, token)
    .then((access) => {
      const sopAccess = {
        is_authorized: !!access.is_authorized,
        is_admin: !!access.is_admin,
        organization_id: access.organization_id || null,
      };
      dispatch({ type: userConstants.SOP_ACCESS_SET, sopAccess });
    })
    .catch(() => {
      const sopAccess = { is_authorized: false };
      dispatch({ type: userConstants.SOP_ACCESS_SET, sopAccess });
    });
};

const hydrateOrgUserList = (organizationId) => (dispatch) => {
  if (!organizationId) {
    return;
  }

  assetActions
    .getUsersList(organizationId)
    .then((response) => {
      dispatch(setOrgUserList(response?.user));
    })
    .catch(() => {
      dispatch(setOrgUserList([]));
    });
};

function login(username, password) {
  return (dispatch) => {
    const startedAt = Date.now();
    dispatch(request({ username }));
    userService.login(username, password).then(
      (user) => {
        if (user.user && user.status === "OK") {
          Mixpanel.trackAuthenticationEvent({
            eventName: "Sign In",
            status: "Successful",
            startedAt,
            user: user.user[0],
          });
          setTokenCookie(user.token);
          setCredentials(username, password);
          dispatch(success(user));
          dispatch(hydrateOrgUserList(user?.user?.[0]?.organizationId));
          bootstrap(dispatch);
          dispatch(persistSopAccess(user.user[0]?.emailAddr || username, user.token));
          const isHomeMigration = getFeatureToggle("HomePage Migration")[0];
          if (
            isHomeMigration &&
            !isHomeMigration.isVisible &&
            history.location.pathname === "/login"
          ) {
            history.push(
              getLocale(history.location.pathname, true) + "/measurements",
            );
          } else if (!getCookie("inviteAcceptedWithExistingLogin")) {
            redirectOnLogin(user);
          }
        } else {
          Mixpanel.trackAuthenticationEvent({
            eventName: "Sign In",
            status: "Failed",
            startedAt,
            email: username,
          });
          dispatch(failure(user));
        }
      },
      (error) => {
        Mixpanel.trackAuthenticationEvent({
          eventName: "Sign In",
          status: "Failed",
          startedAt,
          email: username,
        });
        dispatch(failure(error));
        //bootstrap(dispatch);
        dispatch(alertActions.error(error));
      },
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function socialLogin(data) {
  return (dispatch) => {
    const startedAt = Date.now();
    const provider = data.authUser?.provider?.toUpperCase();
    const eventName = provider === "APPLE" ? "Sign In via Apple" : "Sign In via Google";
    dispatch(request({ username: data.username }));
    userService
      .socialLogin(data)
      .then(
        (user) => {
          if (user.user && user.status === "OK") {
            Mixpanel.trackAuthenticationEvent({
              eventName,
              status: "Successful",
              startedAt,
              user: user.user[0],
            });
            setTokenCookie(user.token);
            dispatch(success(user));
            dispatch(hydrateOrgUserList(user?.user?.[0]?.organizationId));
            bootstrap(dispatch);
            dispatch(persistSopAccess(user.user[0]?.emailAddr || data.username, user.token));
            const isHomeMigration = getFeatureToggle("HomePage Migration")[0];
            if (
              isHomeMigration &&
              !isHomeMigration.isVisible &&
              history.location.pathname === "/login"
            ) {
              history.push(
                getLocale(history.location.pathname, true) + "/measurements",
              );
            } else {
              redirectOnLogin(user);
            }
          } else {
            Mixpanel.trackAuthenticationEvent({
              eventName,
              status: "Failed",
              startedAt,
              email: data.authUser?.emailId,
            });
            dispatch(failure(user));
          }
        },
        (error) => {
          Mixpanel.trackAuthenticationEvent({
            eventName,
            status: "Failed",
            startedAt,
            email: data.authUser?.emailId,
          });
          dispatch(failure(error));
          //bootstrap(dispatch);
          dispatch(alertActions.error(error));
        },
      )
      .catch((err) => {
        console.log("error in social login", err);
      });
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    if (error.status === "objectExists") {
      return { type: userConstants.SOCIAL_EMAIL_ALREADY_EXISTS, error };
    }
    return { type: userConstants.SOCIAL_LOGIN_ERROR, error };
  }
}

function bootstrap(dispatch) {
  dispatch(bootstrapActions.measurements());
}

function userData() {
  return (dispatch) => {
    return userService.userData().then(
      (user) => {
        dispatch(success(user));
        dispatch(hydrateOrgUserList(user?.user?.[0]?.organizationId));
        bootstrap(dispatch);
        return user;
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
        return false;
      },
    );
  };
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function autologin(email, password) {
  return (dispatch) => {
    return userService.login(email, password).then(
      (user) => {
        if (user && user.user && user.status === "OK") {
          setTokenCookie(user.token);
          dispatch({ type: userConstants.LOGIN_SUCCESS, user });
          dispatch(hydrateOrgUserList(user?.user?.[0]?.organizationId));
          bootstrap(dispatch);
        } else {
          clearCredentials();
          clearTokenCookie();
          dispatch({ type: userConstants.LOGOUT });
          history.push(getLocale(history.location.pathname, true) + "/stores/login");
        }
      },
      () => {
        clearCredentials();
        clearTokenCookie();
        dispatch({ type: userConstants.LOGOUT });
        history.push(getLocale(history.location.pathname, true) + "/stores/login");
      },
    );
  };
}

function updateUser(user) {
  return { type: userConstants.UPDATE_USER, user };
}

function logout() {
  clearTokenCookie();
  clearCredentials();
  userService.logout();
  return { type: userConstants.LOGOUT };
}

function logoutFromAdminPortal() {
  clearTokenCookie();
  clearCredentials();
  userService.logoutFromAdminPortal();
  return { type: userConstants.LOGOUT };
}

function setOrgUserList(orgUserList) {
  return { type: userConstants.SET_ORG_USER_LIST, orgUserList };
}

function registration(
  firstName,
  lastName,
  emailAddress,
  password,
  roleId,
  userAccountId,
  isEmailOk,
  jobRoleId,
  countryId,
  organizationId,
) {
  return (dispatch) => {
    dispatch(request({ emailAddress }));

    userService
      .registration(
        firstName,
        lastName,
        emailAddress,
        password,
        roleId,
        userAccountId,
        isEmailOk,
        jobRoleId,
        countryId,
        organizationId,
      )
      .then(
        (user) => {
          dispatch(success(user));
          history.push("/login");
        },
        (error) => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        },
      );
  };

  function request(user) {
    return { type: userConstants.REGISTER_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.REGISTER_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.REGISTER_FAILURE, error };
  }
}

function loginToAdminPortal(username, password) {
  return (dispatch) => {
    dispatch(request({ username }));
    userService.loginToAdminPortal(username, password).then(
      (user) => {
        if (user.user && user.status === "OK") {
          setTokenCookie(user.token);
          dispatch(success(user));
          dispatch(hydrateOrgUserList(user?.user?.[0]?.organizationId));
          history.push(
            getLocale(history.location.pathname, true) + "/admin/dashboard",
          );
          bootstrap(dispatch);
        } else {
          dispatch(failure(user));
        }
      },
      (error) => {
        dispatch(failure(error));
        //bootstrap(dispatch);
        dispatch(alertActions.error(error));
      },
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}
